/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsvatexempt2Inputs */

const en_ticketsvatexempt2 = /** @type {(inputs: Ticketsvatexempt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None, for example small business`)
};

const de_ticketsvatexempt2 = /** @type {(inputs: Ticketsvatexempt2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine, zum Beispiel Kleinunternehmer`)
};

/**
* | output |
* | --- |
* | "None, for example small business" |
*
* @param {Ticketsvatexempt2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsvatexempt2 = /** @type {((inputs?: Ticketsvatexempt2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsvatexempt2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsvatexempt2(inputs)
	return de_ticketsvatexempt2(inputs)
});
export { ticketsvatexempt2 as "ticketsVatExempt" }